module.exports = __webpack_public_path__ + "static/media/screenshot-smart.95c1ecba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/screenshot-smart.jpg
// module id = 648
// module chunks = 0